<template>
  <div class="box has-text-centered">
    <h3>Konnte dir diese Seite weiterhelfen?</h3>
    <div class="buttons is-centered m-0" v-show="!has_answered">
      <button class="button is-success" @click="answer(1)">
        <span class="icon">
          <i class="fas fa-thumbs-up"></i>
        </span>
        <span>Ja</span>
      </button>
      <button class="button is-danger" @click="answer(0)">
        <span class="icon">
          <i class="fas fa-thumbs-down"></i>
        </span>
        <span>Nein</span>
      </button>
    </div>
    <p class="is-size-7-mobile" v-show="has_answered">
      Vielen Dank für dein Feedback!
      <br />
      Wenn du ausführlicheres Feedback geben möchtest, schreib mir einfach eine E-Mail an
      <a href="mailto:kontakt@elektrotechnik-rechner.at">kontakt@elektrotechnik-rechner.at</a>
      .
    </p>
  </div>
</template>

<script>
export default {
  name: 'FeedbackBox',
  methods: {
    answer (feedback) {
      this.has_answered = true
      this.$matomo && this.$matomo.trackEvent(this.$router.currentRoute.path, 'feedback', '', feedback)
    }
  },
  data () {
    return {
      has_answered: false
    }
  }
}
</script>
